import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M8 1.25A6.75 6.75 0 1 0 14.75 8 6.76 6.76 0 0 0 8 1.25Zm0 12A5.25 5.25 0 1 1 13.25 8 5.26 5.26 0 0 1 8 13.25Zm2.49-3.82a.75.75 0 0 1 0 1.06.75.75 0 0 1-1.06 0L8 9.07l-1.42 1.42a.74.74 0 0 1-.53.22.71.71 0 0 1-.53-.22.74.74 0 0 1 0-1.06L7 8 5.52 6.58a.75.75 0 0 1 1.06-1.06L8 7l1.43-1.48a.74.74 0 0 1 1.06 0 .75.75 0 0 1 0 1.06L9.07 8Z';
const draw24px = 'M12,2.25A9.75,9.75,0,1,0,21.75,12,9.76,9.76,0,0,0,12,2.25Zm0,18A8.25,8.25,0,1,1,20.25,12,8.26,8.26,0,0,1,12,20.25ZM16.07,15a.75.75,0,0,1-.54,1.28.74.74,0,0,1-.53-.22l-3-3-3,3a.71.71,0,0,1-.53.22.74.74,0,0,1-.53-.22.75.75,0,0,1,0-1.06l3-3-3-3A.75.75,0,0,1,9,7.94l3,3,3-3a.77.77,0,0,1,1.07,0,.75.75,0,0,1,0,1.06l-3,3Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const XCircleIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'xCircle'));
XCircleIcon.displayName = 'XCircleIcon';
XCircleIcon.propTypes = Icon.propTypes;
XCircleIcon.renderIcon = props => /*#__PURE__*/React.createElement(XCircleIcon, props);
export default XCircleIcon;
//# sourceMappingURL=XCircleIcon.js.map